export const NAVY = "#0A192F";
export const TEAL = "#0D9488";
export const TEAL_BRIGHT = "#14B8A6";
export const GOLD = "#C9A227";

// Full-colour client artwork (dark-background glow version, presented as tiles)
export const RDMonogram = ({ size = 120, className = "" }) => (
  <img
    src="/logo-mark.png"
    alt="RD Cleaning Services monogram"
    style={{ width: size, height: "auto" }}
    className={`rounded-xl shadow-lg ${className}`}
  />
);

export const RDBadge = ({ size = 120, className = "" }) => (
  <img
    src="/logo-mark.png"
    alt="RD Cleaning Services badge"
    style={{ width: size, height: "auto" }}
    className={`rounded-[22%] shadow-lg ${className}`}
  />
);

// Primary lockup — full artwork incl. CLEANING SERVICES
export const RDPrimary = ({ size = 220, className = "" }) => (
  <img
    src="/logo.png"
    alt="RD Cleaning Services"
    style={{ width: size, height: "auto" }}
    className={`rounded-xl shadow-lg ${className}`}
  />
);

// Horizontal lockup — mark + wordmark (website header, documents)
export const RDHorizontal = ({ dark = false, size = 56 }) => (
  <div className="inline-flex items-center gap-4">
    <img src="/logo-mark.png" alt="" style={{ height: size, width: "auto" }} className="rounded-lg shadow-md" />
    <div className="leading-none">
      <div className={`font-display font-extrabold tracking-tight ${dark ? "text-white" : "text-navy"}`} style={{ fontSize: size * 0.62 }}>
        RD <span style={{ color: GOLD }}>Cleaning</span>
      </div>
      <div className={`font-mono font-semibold uppercase ${dark ? "text-slate-400" : "text-slate-500"}`} style={{ fontSize: size * 0.185, letterSpacing: "0.4em", marginTop: size * 0.09 }}>
        Services · Perth WA
      </div>
    </div>
  </div>
);

// ---- Vector one-colour companion mark (print, embroidery, stamps) ----
export const MonogramPaths = ({ color = NAVY, accent = TEAL, sheen = true, spark = true }) => (
  <>
    {sheen && (
      <path d="M74 9.6 A76 76 0 0 1 119.4 55" fill="none" stroke={accent} strokeWidth="6" strokeLinecap="round" />
    )}
    <rect x="26" y="18" width="22" height="124" fill={color} />
    <path d="M48 18 H80 A25 25 0 0 1 80 68 H48 Z" fill={color} />
    <path d="M74 62 L96 62 L136 142 L110 142 Z" fill={color} />
    <path d="M48 18 A63 63 0 0 1 48 144" fill="none" stroke={color} strokeWidth="20" />
    {spark && (
      <path d="M142 20 L145.5 28.5 L154 32 L145.5 35.5 L142 44 L138.5 35.5 L130 32 L138.5 28.5 Z" fill={accent} />
    )}
  </>
);

export const RDMonoMark = ({ color = "#000000", size = 120, className = "" }) => (
  <svg viewBox="0 0 180 160" width={size} height={(size * 160) / 180} className={className} role="img" aria-label="RD one-colour monogram">
    <MonogramPaths color={color} accent={color} sheen={false} />
  </svg>
);
